import { createContext } from "react";
import { IDynamicFormFullContext } from "../DynamicFormContracts";

export const DynamicFormFullContext = createContext<IDynamicFormFullContext<any>>(null as any);

export interface IDynamicFormFullContextProviderProps<T> {
  context: IDynamicFormFullContext<T>;
  children: any;
}

export function DynamicFormFullContextProvider<T>({
  context,
  children
}: IDynamicFormFullContextProviderProps<T>) {

  return (
    <DynamicFormFullContext.Provider value={context}>
      {children}
    </DynamicFormFullContext.Provider>
  );
}

export default DynamicFormFullContextProvider;
